
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface DailyTargetInputProps {
  hasDailyTarget: boolean;
  setHasDailyTarget: (value: boolean) => void;
  dailyTargetValue: string;
  setDailyTargetValue: (value: string) => void;
  dailyTargetUnit: string;
  setDailyTargetUnit: (value: string) => void;
  measurementUnits: string[];
}

export const DailyTargetInput = ({
  hasDailyTarget,
  setHasDailyTarget,
  dailyTargetValue,
  setDailyTargetValue,
  dailyTargetUnit,
  setDailyTargetUnit,
  measurementUnits
}: DailyTargetInputProps) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center space-x-2">
        <Label htmlFor="hasDailyTarget">Daily Target</Label>
        <input
          type="checkbox"
          id="hasDailyTarget"
          checked={hasDailyTarget}
          onChange={(e) => setHasDailyTarget(e.target.checked)}
          className="rounded border-gray-300 text-primary focus:ring-primary"
        />
      </div>
      
      {hasDailyTarget && (
        <div className="flex space-x-2">
          <Input
            type="number"
            step="0.1"
            min="0"
            value={dailyTargetValue}
            onChange={(e) => setDailyTargetValue(e.target.value)}
            placeholder="Enter target value"
            required={hasDailyTarget}
            className="border-primary/30 focus:border-primary rounded-[--radius]"
          />
          <Select 
            value={dailyTargetUnit} 
            onValueChange={setDailyTargetUnit}
          >
            <SelectTrigger className="w-[120px] rounded-[--radius]">
              <SelectValue placeholder="Select unit" />
            </SelectTrigger>
            <SelectContent>
              {measurementUnits.map((unit) => (
                <SelectItem key={unit} value={unit}>
                  {unit}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
};
